"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidTimezone = exports.isValidCountryCode = exports.getCountryTimezonesForCode = exports.getCountryNameForCode = exports.COUNTRIES = exports.REGIONS = exports.REGION_MAPPING = exports.nowInTimezone = exports.localToTimestamp = exports.TIMEZONES = exports.toTimezoneString = exports.timeZoneNames = exports.timeZonesWithUtc = exports.toDate = exports.toTimestamp = exports.now = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
var countries_and_timezones_1 = __importDefault(require("countries-and-timezones"));
var tzdb_1 = require("@vvo/tzdb");
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
/**
 * The current timestamp (in Unix epoch seconds)
 *
 * @returns
 */
function now() {
    return toTimestamp(new Date());
}
exports.now = now;
/**
 * Convert from a Javascript date to Unix epoch seconds
 *
 * @param date
 * @returns
 */
function toTimestamp(date) {
    return (0, dayjs_1.default)(date).unix();
}
exports.toTimestamp = toTimestamp;
/**
 * Convert from unix epoch seconds to a Javascript Date
 *
 * @param ts
 * @returns
 */
function toDate(ts) {
    // The docs for dayjs suggest that you can put in a Unix epoch seconds here, but it seems to interpret as millis
    // so we convert first
    return (0, dayjs_1.default)(ts * 1000).toDate();
}
exports.toDate = toDate;
exports.timeZonesWithUtc = (0, tzdb_1.getTimeZones)({ includeUtc: true });
exports.timeZoneNames = tzdb_1.timeZonesNames;
function toTimezoneString(t) {
    return t.currentTimeFormat + " (" + t.name + ")";
}
exports.toTimezoneString = toTimezoneString;
// THis is now  called UTC_OFFSETS rather than timezones
exports.TIMEZONES = Array.from(new Set(Object.values(exports.timeZonesWithUtc)
    .sort(function (a, b) { return a.currentTimeOffsetInMinutes - b.currentTimeOffsetInMinutes; })
    .map(toTimezoneString)).values());
function isTimeOffsetValid(offset) {
    // Regular expression pattern to validate offset in "+hh:mm" format
    var offsetPattern = /^(\+|-)(0[0-9]|1[0-4]):([0-5][0-9])$/;
    // Check if the offset matches the pattern
    var isValid = offsetPattern.test(offset);
    return isValid;
}
/**
 * Convert from local date (YYYY-MM-DD) and time (HH:MM) with timezone to timestamp.
 *
 * @param localDate
 * @param localTime
 * @param timezone
 * @returns
 */
function localToTimestamp(localDate, localTime, timezone) {
    var dateInTimezone;
    // Is it just UTC?
    if (exports.timeZoneNames.includes(timezone)) {
        // Treat as a real timezone
        dateInTimezone = dayjs_1.default.tz(localDate + " " + localTime, timezone);
    }
    else {
        // Treat as a timeoffset
        dateInTimezone = (0, dayjs_1.default)(localDate + " " + localTime + " " + timezone);
    }
    return toTimestamp(dateInTimezone.toDate());
}
exports.localToTimestamp = localToTimestamp;
/**
 * Get a dayjs instance for now in a particular timezone
 *
 * @param timezone
 * @returns
 */
function nowInTimezone(timezone) {
    // Is it just UTC?
    if (exports.timeZoneNames.includes(timezone)) {
        // Treat as a real timezone
        return (0, dayjs_1.default)().tz(timezone);
    }
    else {
        // Treat as a timeoffset
        return (0, dayjs_1.default)().utcOffset(timezone);
    }
}
exports.nowInTimezone = nowInTimezone;
exports.REGION_MAPPING = { ROW: "Rest Of World" };
exports.REGIONS = Object.keys(exports.REGION_MAPPING).sort();
exports.COUNTRIES = Object.values(countries_and_timezones_1.default.getAllCountries())
    .map(function (x) { return x.id; })
    .sort();
function getCountryNameForCode(code) {
    var c = countries_and_timezones_1.default.getCountry(code);
    return c != null ? c.name : null;
}
exports.getCountryNameForCode = getCountryNameForCode;
function getCountryTimezonesForCode(code) {
    var _a;
    return ((_a = exports.timeZonesWithUtc
        .filter(function (t) { return t.countryCode == code; })
        .map(toTimezoneString)) !== null && _a !== void 0 ? _a : []);
}
exports.getCountryTimezonesForCode = getCountryTimezonesForCode;
function isValidCountryCode(code) {
    var c = getCountryNameForCode(code);
    return c != null;
}
exports.isValidCountryCode = isValidCountryCode;
function isValidTimezone(timezone) {
    // Does it appear to be valid ?
    var tz = exports.timeZonesWithUtc.find(function (t) { return t.name === timezone; });
    if (tz != null) {
        // Try using it with dayjs()
        try {
            dayjs_1.default.tz(new Date(), timezone);
            return true;
        }
        catch (_err) {
            return false;
        }
    }
    // Is it just a UTC offset?
    if (isTimeOffsetValid(timezone)) {
        return true;
    }
    // Not sure what it is, so not a timezone!
    return false;
}
exports.isValidTimezone = isValidTimezone;
